import { Pipe, PipeTransform } from '@angular/core';

import { SingleDatePickerItem } from '../interfaces/single-date-picker-item.interface';

import { isDateItemWithinDateRange } from 'Angular/features/components/date-controls/single-date-picker/utils/single-date-picker-utils';

/**
 * Is Date Within Date Range Pipe
 *
 * Checks if a given date item is inside a date range defined by two Date objects
 */
@Pipe({
    name: 'isDateItemWithinDateRange',
    standalone: false,
})
export class isDateItemWithinDateRangePipe implements PipeTransform {
    transform(dateItem: SingleDatePickerItem, startDate: Date | null, endDate: Date | null): boolean {
        return isDateItemWithinDateRange(dateItem, startDate, endDate);
    }
}
